import React from "react";
import { ContactTheRegulator } from "../../../domain/ContactTheRegulator";
import { SendMessageDialog } from "./dialogs/SendMessageDialog";
import { DialogType, EntityDialog } from "./types";

type RenderDialogProps = {
  focussedEntity: EntityDialog | null;
  onClose: () => void;
  contactTheRegulator: ContactTheRegulator;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  contactTheRegulator,
}) => {
  if (!focussedEntity) {
    return null;
  }

  const { dialogType } = focussedEntity;

  if (dialogType === DialogType.SendMessage) {
    return (
      <SendMessageDialog onClose={onClose} resource={contactTheRegulator} />
    );
  } else {
    const activity = focussedEntity.focussedActivity!;
    switch (activity.activityType) {
      // TODO: add activity dialog renderers here
      default:
        return null;
    }
  }
};
